import type Model from '@ember-data/model';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports
import type DS from 'ember-data';

/**
 * Represent a model's attributes (as keys) without underlying Model class properties.
 */
export type ModelAttrs<T extends Model> = keyof Omit<T, keyof Model>;
/**
 * Represent a model's attributes without underlying Model class properties.
 */
export type ModelData<T extends Model> = Omit<T, keyof Model>;
export type RecordArray<T> = DS.RecordArray<T>;

export type NonEmptyArray<T> = [T, ...T[]];
export function isNonEmptyArray<T>(arr: T[]): arr is NonEmptyArray<T> {
  return arr.length > 0;
}
export type KeysMatching<T, V> = { [K in keyof T]-?: T[K] extends V ? K : never }[keyof T];
